import React, { useRef, useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import Checkmark from './components/Checkmark';
import BMText from '../Text/BMText';
import { useBMTheme } from '../../theme';
const BMCheckbox = (props) => {
    var _a, _b, _c;
    const { BMComponents, BMPrimitives } = useBMTheme();
    const pressableRef = useRef(null);
    const { label, description, value, onChange, sideLabel, disabled, error, customTextColor, indeterminate, testID } = props;
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);
    const [errorState, setErrorState] = useState(error);
    const labelColor = (_a = customTextColor === null || customTextColor === void 0 ? void 0 : customTextColor.label) !== null && _a !== void 0 ? _a : BMComponents.BMStyleTextInkPrimary;
    const descriptionColor = (_b = customTextColor === null || customTextColor === void 0 ? void 0 : customTextColor.description) !== null && _b !== void 0 ? _b : BMComponents.BMStyleTextInkSecondary;
    const contentColor = (_c = customTextColor === null || customTextColor === void 0 ? void 0 : customTextColor.value) !== null && _c !== void 0 ? _c : BMComponents.BMStyleTextInkSecondary;
    if (error != errorState) {
        setErrorState(error);
    }
    //handlers
    const handleHoverIn = () => {
        setHovered(true);
    };
    const handleHoverOut = () => {
        setHovered(false);
    };
    const handlePress = () => {
        const newValue = !value;
        setFocused(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    const handleFocus = () => {
        setFocused(true);
    };
    const handleBlur = () => {
        setFocused(false);
    };
    return (<Pressable ref={pressableRef} style={styles.container} onPress={handlePress} onHoverIn={handleHoverIn} onHoverOut={handleHoverOut} onFocus={handleFocus} onBlur={handleBlur} disabled={disabled} testID={testID}>
      <Checkmark value={value} hover={hovered} focus={focused} disabled={disabled} error={error} indeterminate={indeterminate}/>
      <View style={[styles.labelContainer, { marginLeft: BMPrimitives.BMSize.md }]}>
        {label && (<BMText style={{
                ...BMPrimitives.BMTypography.uiLarge,
                color: disabled ? BMComponents.BMStyleTextInkMuted : labelColor,
            }}>
            {label}
          </BMText>)}
        {description && (<BMText style={{
                ...BMPrimitives.BMTypography.uiNormal,
                color: disabled ? BMComponents.BMStyleTextInkMuted : descriptionColor,
            }}>
            {description}
          </BMText>)}
      </View>
      {sideLabel && (<View style={styles.sideLabelContainer}>
          <BMText style={{
                ...BMPrimitives.BMTypography.uiNormal,
                color: disabled ? BMComponents.BMStyleTextInkMuted : contentColor,
            }}>
            {sideLabel}
          </BMText>
        </View>)}
    </Pressable>);
};
export default BMCheckbox;
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        alignSelf: 'flex-start',
        // @ts-ignore
        outlineStyle: 'none',
    },
    labelContainer: { flex: 2 },
    sideLabelContainer: {
        marginLeft: 12,
        marginTop: 3,
        flex: 1,
    },
});
